

import { 
    Container,
} from "react-bootstrap";
import PDFPage9Table1 from "./pdf-page-9/PDFPage9Table1";
import PDFPage9Table2 from "./pdf-page-9/PDFPage9Table2";
import PDFPage9Table3 from "./pdf-page-9/PDFPage9Table3";

function PDFPage9(props: any) {
    return (
        <>
            <Container fluid className="text-left page-break cu-pt-10">
                <h3 className="cu-fs-18">{props.TranslateString("pts_12_–_korjaustarpeet")}​ ​</h3>
                <PDFPage9Table1 {...props} data={props?.ptsData?.upcoming}/>
            </Container>
            <Container fluid className="text-left page-break cu-pt-10">
                <h3 className="cu-fs-18">{props.TranslateString("pts_23_–_kaynnissa_olevat_korjaukset")}​ ​</h3>
                <PDFPage9Table3 {...props} data={props?.ptsData?.ongoing}/>
            </Container>
            <Container fluid className="text-left cu-pt-10">
                <h3 className="cu-fs-18">{props.TranslateString("pts_22_–_tehdyt_merkittävät_korjaukset")}​</h3>
                <PDFPage9Table2 {...props}  data={props?.ptsData?.done}/>
            </Container>
        </>
    );
}

export default PDFPage9;